import { render, staticRenderFns } from "./form-person-address.vue?vue&type=template&id=7e40965f&scoped=true"
import script from "./form-person-address.vue?vue&type=script&lang=js"
export * from "./form-person-address.vue?vue&type=script&lang=js"
import style0 from "./form-person-address.vue?vue&type=style&index=0&id=7e40965f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e40965f",
  null
  
)

export default component.exports